import { gql } from '@apollo/client';

export const GET_INDEXED_EVM_NFT_BY_TEMPLATE_ID_QUERY = gql`
  query GetIndexedEvmNFTByTemplateId(
    $data: GetIndexedEvmNFTByTemplateIdInput!
  ) {
    getIndexedEvmNFTByTemplateId(data: $data) {
      name
      image {
        originalUrl
      }
      description
      structuredAttributes
      totalTokens
      distinctOwners
    }
  }
`;
